import { msg } from 'gt-react';
import { ArrowCounterClockwiseIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
} from '../../route';

const ObsoleteProductsPage = lazyRouteComponent(
  () => import('./ObsoleteProductsPage'),
  'ObsoleteProductsPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/procurement/obsolete-products',
  staticData: {
    app: {
      nav: {
        label: msg('Obsolete & Returns', {
          context: 'sidebar nav label, Procurement section',
        }),
        icon: <ArrowCounterClockwiseIcon className="h-4 w-4" weight="fill" />,
        group: 'Procurement',
        order: 37,
        groupOrder: 30,
        defaultHidden: true,
      },
      access: {
        modulesAnyOf: [ProductModule.PROCUREMENT],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Inventory }],
      },
    },
  },
  component: ObsoleteProductsPage,
  loader: () => ({
    crumb: msg('Obsolete & Returns', { context: 'page breadcrumb' }),
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PROCUREMENT],
    });
  },
});
